import * as React from 'react';
import {
  Box,
  Button,
  CopyableHash,
  Form,
  FormBody,
  FormGroup,
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalSection,
  themeUtils as tu,
  Title,
} from '@zen-common/components-base';
import { TechnicalData as TD } from '@zen/common-app-parts';
import styled, { css } from 'styled-components';
import { numberUtils, textUtils } from '@zen/common-utils';

export default function ShowMoreResult({ values, hide }) {
  const {
    item: { key, value },
    timestamp,
    commit,
    hash,
    path,
    index,
    root,
  } = values;
  return (
    <Modal>
      <ModalContent large onClose={() => hide()}>
        <ModalHeader>
          <Title>More Information</Title>
        </ModalHeader>
        <ModalSection>
          <Form>
            <FormBody>
              <>
                <FormGroup>
                  <Box>
                    <TD.Label>Ticker:</TD.Label>
                    <TD.Value>{key}</TD.Value>
                  </Box>
                </FormGroup>
                <FormGroup>
                  <Box>
                    <TD.Label>Timestamp:</TD.Label>
                    <TD.Value>{textUtils.getDateStringFromTimestamp(timestamp)}</TD.Value>
                  </Box>
                </FormGroup>
                <FormGroup>
                  <Box>
                    <TD.Label>Epoch Timestamp:</TD.Label>
                    <TD.Value>{timestamp}</TD.Value>
                  </Box>
                </FormGroup>
                <FormGroup>
                  <Box>
                    <TD.Label>Price:</TD.Label>
                    <TD.Value>$ {numberUtils.getPrice(value)}</TD.Value>
                  </Box>
                </FormGroup>
                <FormGroup>
                  <Box>
                    <TD.Label>Root:</TD.Label>
                    <TD.Value>
                      <CopyableHash hash={root} />
                    </TD.Value>
                  </Box>
                </FormGroup>
                <FormGroup>
                  <Box>
                    <TD.Label>Commit:</TD.Label>
                    <TD.Value>
                      <CopyableHash hash={commit} />
                    </TD.Value>
                  </Box>
                </FormGroup>
                <FormGroup>
                  <Box>
                    <TD.Label>Hash:</TD.Label>
                    <TD.Value>
                      <CopyableHash hash={hash} />
                    </TD.Value>
                  </Box>
                </FormGroup>
                <FormGroup>
                  <Box>
                    <TD.Label>Index:</TD.Label>
                    <TD.Value>{numberUtils.toDisplay(index)}</TD.Value>
                  </Box>
                </FormGroup>
                <FormGroup>
                  <TD.Section>
                    <Box>
                      <TD.Label>Audit Path:</TD.Label>
                    </Box>
                    <Table>
                      {path.map((audit, index) => (
                        <Row key={index}>
                          <Col>
                            <TD.Label>-</TD.Label>
                            <TD.Value>
                              <CopyableHash hash={audit} />
                            </TD.Value>
                          </Col>
                        </Row>
                      ))}
                    </Table>
                  </TD.Section>
                </FormGroup>
              </>
            </FormBody>
          </Form>
        </ModalSection>
        <ModalFooter>
          <Button type="button" bg="secondary" onClick={hide}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

const Col = styled(Box)`
  ${tu.mq({
    display: ['block', null, 'table-cell'],
  })}
`;
const Row = styled(Box)`
  ${css(
    tu.mq({
      display: ['block', null, 'table-row'],
      marginBottom: [tu.space('sm'), null, 0],
    })
  )}

  &:last-child {
    margin-bottom: 0;
  }
`;
const Table = styled(Box)`
  ${tu.mq({
    display: ['block', null, 'table'],
  })}
`;
